import React from 'react';
import { Link } from 'react-router-dom';
import './Cart.css';

const Cart = ({ cartItems, removeFromCart }) => {
  return (
    <div className="cart-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Shopping Cart</h1>
          <p className="page-subtitle">
            {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'} in your cart
          </p>
        </div>
      </div>

      <div className="container">
        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <div className="empty-cart-icon">
              <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
            </div>
            <h2 className="empty-cart-title">Your cart is empty</h2>
            <p className="empty-cart-description">
              Looks like you haven't added any products to your cart yet.
            </p>
            <Link to="/products" className="btn-continue-shopping">
              Continue Shopping
            </Link>
          </div>
        ) : (
          <>
          <div className="cart-content">
            <div className="cart-items">
              <div className="cart-table-header">
                <div className="header-product">Product</div>
                <div className="header-price">Price</div>
                <div className="header-quantity">Quantity</div>
                <div className="header-total">Total</div>
                <div className="header-action"></div>
              </div>

              {cartItems.map((item, index) => (
                  <div key={index} className="cart-item">
                  <div className="item-product">
                    <div className="item-image">
                      {(item.images?.[0] || item.image)
                        ? <img src={item.images?.[0] || item.image} alt={item.name} className="item-img" onError={e => e.target.style.display='none'} />
                        : <div className="item-placeholder">{item.name.charAt(0)}</div>
                      }
                    </div>
                    <div className="item-details">
                      <h3 className="item-name">{item.name}</h3>
                      <span className="item-category">{item.category}</span>
                    </div>
                  </div>

                  <div className="item-price">
                    <span>{item.price}</span>
                  </div>

                  <div className="item-quantity">
                    <span>1</span>
                  </div>

                  <div className="item-total">
                    <span>{item.price}</span>
                  </div>

                  <div className="item-action">
                    <button
                      onClick={() => removeFromCart(item.id)}
                      className="btn-remove"
                      aria-label="Remove item"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <div className="summary-card">
                <h3 className="summary-title">Order Summary</h3>

                <div className="summary-row">
                  <span className="summary-label">Subtotal</span>
                  <span className="summary-value">Contact Us</span>
                </div>

                <div className="summary-row">
                  <span className="summary-label">Shipping</span>
                  <span className="summary-value">Calculated at checkout</span>
                </div>

                <div className="summary-row">
                  <span className="summary-label">Tax</span>
                  <span className="summary-value">Calculated at checkout</span>
                </div>

                <div className="summary-divider"></div>

                <div className="summary-row total">
                  <span className="summary-label total-label">Total</span>
                  <span className="summary-value total-value">Contact Us</span>
                </div>

                <Link to="/contact" className="btn-checkout" style={{display:'flex',alignItems:'center',justifyContent:'center',gap:8,textDecoration:'none'}}>
                  Request a Quote
                </Link>

                <Link to="/products" className="btn-continue">
                  Continue Shopping
                </Link>

                <div className="secure-checkout">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                  <span>Secure Checkout</span>
                </div>
              </div>

              <div className="promo-card">
                <h3 className="promo-title">Have a promo code?</h3>
                <div className="promo-input">
                  <input type="text" placeholder="Enter promo code" />
                  <button className="btn-apply">Apply</button>
                </div>
              </div>
            </div>
          </div>

          <div className="cart-quote-banner">
            <p><strong>Need a bulk or custom quote?</strong>Our team will prepare a tailored offer with GST, freight & delivery timelines.</p>
            <Link to="/contact" className="btn-get-quote">Get a Quote →</Link>
          </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
